// Styles for InternetBar go here.
import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, baseVariables, contextualVariable } from '@marriott/mi-ui-library';

export const StyledInternetBar = styled.div`
  ${rtl`
    .internet-bar-container {
      font-family: ${contextualVariable.brandedFontFamily};
      position: absolute;
      width: fit-content;
      height: fit-content;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      inset: 0;
      margin: auto;
      max-width: 90vw;
      border-radius: ${toRem(15)};
      border-bottom: ${toRem(10)} solid ${contextualVariable.accentColor};

      &.internet-bar-container-loader {
        border: 0;
      }

      @media ${baseVariables.mediaQuery.md} {
        max-width: ${toRem(625)};
      }

      @media ${baseVariables.mediaQuery.lg} {
        max-width: ${toRem(695)};
      }


      a[disabled] {
        pointer-events: none;
        cursor: not-allowed;
      }

      button.disable-join-now {
        pointer-events: none;
        cursor: not-allowed;
      }
        
      button.enable-join-now {
        pointer-events: auto;
        cursor: pointer;
      }

      .internet-bar-content {
        .loyalty-container {
          &-card1 {
            @media ${baseVariables.mediaQuery.md} {
              padding-right: ${toRem(12)} !important;
            }
            @media ${baseVariables.mediaQuery.xl} {
              padding-right: ${toRem(8)} !important;
            }
          }
          &-card2 {
            padding-left: ${toRem(8)} !important;
            @media ${baseVariables.mediaQuery.md} {
              padding-left: ${toRem(12)} !important;
            }
            @media ${baseVariables.mediaQuery.xl} {
              padding-left: ${toRem(8)} !important;
            }
          }
          &__separator {
          border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
          }
        }
        &__icon {
          border-radius: 50%;
          padding: ${toRem(8)} ${toRem(10)} ${toRem(6)};
          border: ${toRem(1)} solid ${contextualVariable.accentColor};
          font-size: ${baseVariables.font['fontXxl']};
        }

        &__separator {
          width: ${toRem(100)};
          border-bottom: ${toRem(2)} solid ${contextualVariable.accentColor};
          margin: auto;
        }
        &__footer-container {
          &__tnc-text-conference {
            margin: ${toRem(10)};
          }
        }
      }

      &-loader {
        background: transparent;
      }
    }

    .internet-bar-container {
      .internet-bar-content {
        &__button-container {
          &-item {
            @media ${baseVariables.mediaQuery.md} {
              a, button {
                min-width: ${toRem(160)}
              }
            }
          }
        }
      }
    }

    .internet-bar-container {
      .internet-bar-content-in_stay {
        padding: 0 ${toRem(24)};
        margin-bottom: ${toRem(-3)};
        min-width: ${toRem(280)};
        
        @media ${baseVariables.mediaQuery.lg} {
          width: ${toRem(555)};
        }
        
        &-signed-in {
          @media ${baseVariables.mediaQuery.xl} {
            padding 0 ${toRem(32)} !important;
          }
        }

        &__description-container{
          p a {
            text-decoration: underline;
            cursor: pointer;
          }
        }

        &-signed-out{
          @media ${baseVariables.mediaQuery.xl} {
            padding 0 ${toRem(32)} !important;
          }
        }
      }

      .internet-bar-content-upgrade, .internet-bar-content-upgraded {
        padding: 0 ${toRem(24)};
        min-width:  ${toRem(280)};
        
        @media ${baseVariables.mediaQuery.lg} {
          width: ${toRem(555)};
          padding: 0 ${toRem(32)} !important;
        }
        &__description-container {
          p a {
            text-decoration: underline;
            cursor: pointer;
          }
        }
        &__footer-container {
          p a {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }

    .internet-bar-container {
      .internet-bar-content-connected {
        padding: 0 ${toRem(24)};
        min-width: ${toRem(280)};
        position: relative;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin-bottom: ${toRem(-3)};

        @media ${baseVariables.mediaQuery.xl} {
          width: ${toRem(555)};
          padding 0 ${toRem(32)} !important;
        }
        &__description-container{
          p a {
            text-decoration: underline;
            cursor: pointer;
          }
        }

        &__button-content {
          > a:only-child {
            margin-bottom: ${toRem(48)};
          }

          > :first-child:not(:only-child) {
            margin-bottom: ${toRem(16)};

            @media ${baseVariables.mediaQuery.xl} {
              margin-bottom: ${toRem(8)};
            }
          }
        }
      }
    }

    .internet-bar-container {
      .internet-bar-content-preconnect {
        padding: 0 ${toRem(24)};
        min-width: ${toRem(280)};

        @media ${baseVariables.mediaQuery.lg} {
          padding: 0 ${toRem(32)};
          width: ${toRem(555)};
        }
        &__description-container {
          p a {
            text-decoration: underline;
            cursor: pointer;
          }
        }
        &__footer-container { 
          p a {
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
    }

    .internet-bar-container {
      .internet-bar-content-preconnect-loyalty {
        padding: 0 ${toRem(16)};
        min-width: ${toRem(280)};

        @media ${baseVariables.mediaQuery.md} {
          padding: 0 ${toRem(32)};
          width: ${toRem(584)};
        }

        @media ${baseVariables.mediaQuery.lg} {
          padding: 0 ${toRem(32)};
          width: ${toRem(650)};
        }

        .internet-bar-content__footer-container {
          &__tnc-text a {
            text-decoration: underline;
            cursor: pointer;
          }
        }
        
        .loyalty-buttons {
          min-width: ${toRem(140)};
          &:lang(EN){
            width: ${toRem(160)};
          }
        }
      }
    }

    .flex-1 {
      flex: 1;
    }

    .internet-bar-container:has(> .internetbar-conservative-container) {
      border-radius: ${toRem(14)};
      border-bottom: 0;
    }

    .internet-bar-container .internetbar-conservative-container {
      .internetbar-conservative-content {
        @media ${baseVariables.mediaQuery.md} {
          width: ${toRem(625)};
          .t-subtitle-xl {
            font-size: ${toRem(29)};
            line-height: ${toRem(32)};
          }
        }

        @media ${baseVariables.mediaQuery.lg} {
          width: ${toRem(695)};
        }

        .loyalty-container {
          .loyalty-description-title {
            color: ${baseVariables.color.base10};
            font-size: ${baseVariables.font['fontS']};
            font-weight: ${baseVariables.font['fontWeightMedium']};
            line-height: ${toRem(21)};
          }

          .loyalty-description {
            color: ${contextualVariable.brandedAltColor};
            font-size: ${baseVariables.font['fontS']};
            font-weight: ${baseVariables.font['fontWeightRegular']};
            line-height: ${toRem(21)};
          }

          .loyalty-buttons {
            min-width: ${toRem(128)};
            white-space: nowrap;
          }
        }

        &__separator {
          border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
        }


        &__footer-container__tnc-text {
          color: ${contextualVariable.brandedAltColor};
          line-height: ${toRem(18)};
          margin: ${toRem(10)};

          a {
            text-decoration: underline;
            font-weight:  ${baseVariables.font['fontL']};
            color: ${contextualVariable.linkTextColor};
            cursor: pointer;
            word-break: break-all;
          }
        }

        &__footer-container__offers-tnc-text {
          text-align: left;
        }
      }
    }

    .internet-bar-container:has(> .internetbar-marketing-container) {
      border-radius: ${toRem(14)};
      border-bottom: 0;
    }

    .internet-bar-container .internetbar-marketing-container {      
      .internetbar-marketing-content {
        @media ${baseVariables.mediaQuery.md} {
          width: ${toRem(625)};
          .t-subtitle-xl {
            font-size: ${toRem(29)};
            line-height: ${toRem(32)};
          }
        }

        @media ${baseVariables.mediaQuery.lg} {
          width: ${toRem(695)};
        }

        .loyalty-container {
          .loyalty-description-title {
            color: ${baseVariables.color.base10};
            font-size: ${baseVariables.font['fontS']};
            font-weight: ${baseVariables.font['fontWeightMedium']};
            line-height: ${toRem(21)};
          }

          .loyalty-description {
            color: ${contextualVariable.brandedAltColor};
            font-size: ${baseVariables.font['fontS']};
            font-weight: ${baseVariables.font['fontWeightRegular']};
            line-height: ${toRem(21)};

            @media ${baseVariables.mediaQuery.md} {
              margin: 0 ${toRem(72)};
            }
          }

          .loyalty-buttons {
            min-width: ${toRem(128)};
            white-space: nowrap;
          }
        }

        &__separator {
          border-bottom: ${toRem(1)} solid ${baseVariables.color['neutral30']};
        }

        &__footer-container__tnc-text {
          color: ${contextualVariable.brandedAltColor};
          line-height: ${toRem(18)};
          margin: ${toRem(10)};

          a {
            text-decoration: underline;
            color: ${contextualVariable.linkTextColor};
            cursor: pointer;
            word-break: break-all;
          }
        }

        &__footer-container__offers-tnc-text {
          text-align: left;
        }
      }
    }
  `}
`;
